import {
  ISettlementTransaction,
  ISettlementTransactionPagedResponse,
} from '../../interfaces/settlement/settlement-transaction.interface';

export abstract class AbstractSettlementService {
  abstract getTransactionsByRespondentAndCycle(
    respondentRtn: string,
    cycleDate: string
  ): Promise<ISettlementTransaction[] | undefined>;

  abstract getTransactionsByRespondentAndCyclePaged(
    respondentRtn: string,
    cycleDate: string,
    page: number,
    pageSize: number,
    sortBy: string,
    sortAsc: boolean,
    filterText: string
  ): Promise<ISettlementTransactionPagedResponse | undefined>;
}
